export type RechargeStatus = 'pending' | 'approved' | 'rejected';
export type PaymentMethod = 'yape' | 'plin' | 'transferencia' | 'tarjeta' | 'efectivo' | 'otro' | string;

export interface SmsPackage {
  id: string;
  name: string;
  sms_credits: number;
  base_price: number;
  tax_rate: number;
  total_price: number;
  price_per_sms: number;
  is_popular: boolean;
  is_active: boolean;
  created_at?: string | null;
}

export interface Recharge {
  id: string;
  user_id: string;
  package_id: string | null;
  sms_credits: number;
  amount: number;
  payment_method: PaymentMethod | null;
  operation_code: string | null;
  status: RechargeStatus;
  created_at: string;
  approved_at: string | null;
  rejected_at: string | null;
  rejection_reason: string | null;
  package: SmsPackage | null;
}

export interface RechargeProfile {
  full_name: string;
  email: string;
  razon_social: string | null;
  ruc: string | null;
}

export interface AdminRecharge extends Recharge {
  profile: RechargeProfile | null;
}

export interface ManualRechargeClient {
  id: string;
  company_id: string | null;
  email: string;
  full_name: string | null;
  razon_social: string | null;
  ruc: string | null;
  is_active: boolean;
  credits: number;
}

export interface CreateRechargeRequest {
  package_id: string;
  sms_credits: number;
  amount: number;
  payment_method: PaymentMethod;
  operation_code?: string | null;
}

export interface CreateManualRechargeRequest {
  company_id: string;
  package_id: string;
  payment_method: PaymentMethod;
  operation_code: string;
  notes?: string | null;
}

export interface CreateManualRechargeResult {
  recharge_id: string;
  new_balance: number;
  sms_credits: number;
  amount: number;
}
